export { FacilitiesTableModal } from './components/FacilitiesTableModal'

export { FacilitiesTableModalType } from './types/types'
export type { OpenFacilitiesTableModalType } from './types/types'
